import { graphql, Link, PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import styled from '@emotion/styled';
import { Box, Container, Stack, Typography } from '@mui/material';
import { AnalyticsPageType } from '@shopify/hydrogen-react';

import { useSeekaConverge } from '@seeka-labs/converge-react';
import Fallback from '../components/fallback';
import SeoHead from '../components/head';
import { HorizontalSlantContainer } from '../components/horizontal-slant-container';
import * as sections from '../components/sections';
import { useAnalytics } from '../shared/analytics';
import { notPrintable } from '../shared/styles/notPrintable';
import { FaqList } from '../templates/faq/faqList';
import { DosageCalculator } from '../templates/use/dosage/calculator';

export default function Dosage(props: PageProps<Queries.ContentfulDosagePageContentQuery>) {
  // const theme = useTheme()
  // const isLargeMobile = useMediaQuery(theme.breakpoints.down("lg"))

  const NotPrintable = React.useMemo(() => styled('div')(notPrintable), []);

  const pageData = props.data?.pageData

  const blockComponents = () => {
    return (pageData?.blocks || []).map((block) => {
      const { id, blockType, ...componentProps } = block as any
      const Component = sections[blockType] || Fallback
      return <Component key={id} {...(componentProps as any)} />
    })
  }
  const seeka = useSeekaConverge();

  const analytics = useAnalytics();
  useEffect(() => {
    analytics.trackPageView(AnalyticsPageType.page);
    seeka.track.viewContentItem({
      contentName: 'Dosage',
    })
  }, [])

  return (
    <>
      <HorizontalSlantContainer id={"dosage"} autoHeight>
        <Container
          sx={{ pt: { xs: "50px", sm: "60px", md: "70px" }, pb: { xs: "30px" }, color: 'white', textAlign: 'center', pageBreakAfter: 'always' }}
        // maxWidth={isLargeMobile ? undefined : "xl"}
        >
          {/* <Stack spacing={2}>
            <Box>
              <Typography variant="h2" gutterBottom>
                Dosage calculator
              </Typography> */}
          {/* <Typography variant="body1">
               Use the calculator below to determine your 
              </Typography> */}
          {/* </Box> */}

          <Box pt={5}>
            {/* SEO */}
            <Typography variant="h1" gutterBottom sx={{ display: 'none' }}>
              Dosage
            </Typography>

            <DosageCalculator isSiteFramed={false} />
          </Box>
          {/* </Stack> */}

        </Container>
      </HorizontalSlantContainer>


      <Box sx={{ pt: { xs: 3, sm: 3, md: 0 } }}>{blockComponents()}</Box>

      <Container sx={{ pt: 6 }}>
        <Stack spacing={6}>
          <Stack spacing={2}>
            <Box>
              <Typography variant="h2" gutterBottom>
                Frequently Asked Questions
              </Typography>
              <NotPrintable>
                <Typography variant="body1">
                  If you have any questions that aren't answered below,{" "}
                  <Link to="/contact">contact us</Link> and we'll get back to you
                  as soon as possible.
                </Typography>
              </NotPrintable>
            </Box>

            <FaqList />
          </Stack>
        </Stack>
      </Container>
    </>
  )
}
export const Head = (props: PageProps) => {
  return (
    <SeoHead
      title="Dosage calculator"
      pathname={props.location.pathname}
      description="Dosage for 1% Methylene Blue Liquid"
    />
  )
}

export const query = graphql`
  query ContentfulDosagePageContent {
    pageData: contentfulPage(slug: { eq: "dosage" }) {
      id
      title
      description
      contentful_id
      slug
      __typename
      blocks: content {
        blockType: __typename
        ...RichTextBlockContent
        # ...HomepageHeroContent
        # ...HomepageFeatureListContent
        ...HomepageCtaContent
        # ...HomepageProductListContent
      }
    }
  }
`
